import { BookOpen, FileText, Link, MessageSquare } from "lucide-react";
import React from "react";
import { Tabs, TabsList, TabsTrigger } from "./ui/tabs";

interface ContentTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  children: React.ReactNode;
}

const ContentTabs: React.FC<ContentTabsProps> = ({
  activeTab,
  onTabChange,
  children,
}) => {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <div className="border-b mb-6">
        <TabsList className="bg-transparent w-full justify-start gap-2">
          <TabsTrigger
            value="disposiciones"
            className="flex items-center gap-2 px-4 py-3 data-[state=active]:tab-active rounded-none transition-all duration-200 hover:bg-secondary/30"
          >
            <FileText className="h-4 w-4 text-primary" />
            <span>Disposiciones y anuncios</span>
          </TabsTrigger>
          <TabsTrigger
            value="notificaciones"
            className="flex items-center gap-2 px-4 py-3 data-[state=active]:tab-active rounded-none transition-all duration-200 hover:bg-secondary/30"
          >
            <MessageSquare className="h-4 w-4 text-primary" />
            <span>Notificaciones</span>
          </TabsTrigger>
          <TabsTrigger
            value="legislacion"
            className="flex items-center gap-2 px-4 py-3 data-[state=active]:tab-active rounded-none transition-all duration-200 hover:bg-secondary/30"
          >
            <BookOpen className="h-4 w-4 text-primary" />
            <span>Legislación consolidada</span>
          </TabsTrigger>
          <TabsTrigger
            value="links"
            className="flex items-center gap-2 px-4 py-3 data-[state=active]:tab-active rounded-none transition-all duration-200 hover:bg-secondary/30"
          >
            <Link className="h-4 w-4 text-primary" />
            <span>Enlaces de interés</span>
          </TabsTrigger>
        </TabsList>
      </div>

      {children}
    </Tabs>
  );
};

export default ContentTabs;
